@import "/src/styles/mixins.sass"

.container
    position: relative

    .inputContainer
        input
            width: 100%

        svg
            transition: transform 0.2s ease

        &.opened svg
            transform: rotate(180deg)

    .list
        position: absolute
        z-index: 20
        min-width: calc(100% - 1rem)
        left: 0.5rem
        top: 100%
        background-color: var(--color-grey-light)
        border: 0.2rem solid var(--color-black-primary)
        border-top-width: 0
        border-radius: 0 0 0.75rem 0.75rem
        max-height: 15rem
        overflow-y: auto
        padding: 0.375rem

        button
            @include input
            width: 100%
            padding: 0.75rem 1rem 0.75rem 0.75rem
            align-items: flex-start !important

            &:hover, &:focus-visible
                background-color: var(--color-grey-primary)
